import { render, staticRenderFns } from "./move-dialog.vue?vue&type=template&id=cea876f4&scoped=true&"
import script from "./move-dialog.vue?vue&type=script&lang=js&"
export * from "./move-dialog.vue?vue&type=script&lang=js&"
import style0 from "./move-dialog.vue?vue&type=style&index=0&id=cea876f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea876f4",
  null
  
)

export default component.exports